<template>
  <div>
    <div class="row-1">
      <div>
        <div v-if="moldValid||configInputs!=0" class="section_field">
          <label class="">
            Cavidades do Molde
          </label>
          <div class="">
            <input
              v-model="numeroTotaldeCavid"
              v-maska="['##', '']"
              :class="['field', 'default_field_width']"
              placeholder="Campo automático"
              disabled
            />
          </div>
        </div>
        <div v-else class="section_field">
          <label class="">
            Cavidades do Molde 
          </label>
          <div class="">
            <input
              v-maska="['##', '']"
              :class="['field', 'default_field_width']"
              placeholder="Campo automático"
              disabled
            />
          </div>
        </div>
      </div>

      <div>
        <div class="section_field" v-if="configInputs==0">
            <label class="">
              Tipos de Injeção
            </label>
            <select v-model="tiposDeInjeçãoOpcao" class="field_select" @change="updateSelectionTipoDeInjecao">
              <option value="" disabled selected>Selecione uma opção</option>
              <option value="1">Direta</option>
              <option value="2">Indireta</option>
              <option value="3">Bico Quente</option>
            </select>
        </div>
        <div class="section_field" v-else-if="configInputs==1">
            <label class="">
              Tipos de Injeção
            </label>
            <select disabled class="field_select">
              <option v-if="dados.tipo_de_injecao.direta === 'true'">Direta</option>
              <option v-else-if="dados.tipo_de_injecao.indireta ==='true'">Indireta</option>
              <option v-else-if="dados.tipo_de_injecao.bico_quente ==='true'">Bico Quente</option>
            </select>
          </div>
        <div class="section_field" v-else>
            <label class="">
              Tipos de Injeção
            </label>
            <select v-model="tiposDeInjeçãoOpcao" class="field_select" @change="updateSelectionTipoDeInjecao">
              <option value="" disabled selected>Selecione uma opção</option>
              <option value="1">Direta</option>
              <option value="2">Indireta</option>
              <option value="3">Bico Quente</option>
            </select>
        </div>
      </div>


        <div class="section_field">
          <label class=""> Máquina Injetora - 1° Opção</label>
          <input
            @click="mapMachine"
            list="MaquinaList"
            v-model="v$.dados.maquinas.op1.$model"
            type="text"
            :class="['field','default_field_width', { error: v$.dados.maquinas.op1.$error }]"
            :placeholder="configInputs == 0 ? 'Informe a máquina' : ''"
            :disabled="configInputs"
          />
          <div class="text-red" v-if="v$.dados.tipo_de_injecao.$error">
            O campo Opção 1 é obrigatório.
          </div>
          <div class="text-red" v-if="validationMachine === true">
            Máquina informada não encontrada no Sap.
          </div>
        </div>

        <div class="section_field">
          <label class="">Máquina Injetora - 2° Opção </label>
          <input
            @click="mapMachine"
            list="MaquinaList"
            v-model="dados.maquinas.op2"
            type="text"
            :class="['field', 'default_field_width']"
            :placeholder="configInputs == 0 ? 'Informe a máquina' : ''"
            :disabled="configInputs"
          />
        </div>

        <div class="section_field">
          <label class=""> Máquina Injetora - 3° Opção </label>
          <input
            @click="mapMachine"
            list="MaquinaList"
            v-model="dados.maquinas.op3"
            type="text"
            :class="['field', 'default_field_width']"
            :placeholder="configInputs == 0 ? 'Informe a máquina' : ''"
            :disabled="configInputs"
          />
        </div>

      <datalist id="MaquinaList">
        <div v-for="(l, index) in listmaquinas" :key="index">
          <option :value="l.codigoMaquina">
            {{ l.codigoMaquina }}
          </option>
        </div>
      </datalist>
      <div>
        <div class="section_field" v-if="configInputs==0">
          <label class="">Molde com Gavetas</label>
          <select v-model="dados.gavetas.selectObject" class="field_select">
            <option value="" disabled selected>Selecione a opção</option>
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>
        <div class="section_field" v-else-if="configInputs==1">
          <label class="">Molde com Gavetas</label>
          <select disabled class="field_select">
            <option v-if="dados.gavetas.selectObject === 'true'">Sim</option>
            <option v-else-if="dados.gavetas.selectObject === 'false'">Não</option>
          </select>
        </div>
        <div class="section_field" v-else>
          <label class="">Molde com Gavetas</label>
          <select v-model="dados.gavetas.selectObject" class="field_select">
            <option value="" disabled selected>Selecione a opção</option>
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>
    </div>
        <div class="section_field" v-show="dados.gavetas.selectObject" style="animation: fadeIn 0.5s ease forwards!important;">
          <label class=""> Lado Móvel das Gavetas</label>
          <input
            v-model="v$.dados.gavetas.lado_movel.$model"
            :class="['field', 'default_field_width']"
            :placeholder= "configInputs == 0 ? 'Selecione a Quantidade' : ''"
            :disabled="configInputs"
          />
          <div class="text-red" v-if="v$.dados.gavetas.lado_movel.$error">
            Opção de Lado Movel requer dados numerico.
          </div>
        </div>

        <div class="section_field" v-show="dados.gavetas.selectObject" style="animation: fadeIn 0.5s ease forwards!important;">
            <label class=""> Lado Fixo das Gavetas</label>
            <input
              v-model="v$.dados.gavetas.lado_fixo.$model"
              :class="['field', 'default_field_width']"
              :placeholder= "configInputs == 0 ? 'Informe a Quantidade' : ''"
              :disabled="configInputs"
            />
          <div class="text-red" v-if="v$.dados.gavetas.lado_fixo.$error">
            Opção de Lado Fixo requer dados numerico.
          </div>
        </div>
      <div>
        <div class="section_field" v-if="configInputs==0" v-show="dados.gavetas.selectObject" style="animation: fadeIn 0.5s ease forwards!important;">
          <label class="">
            Gavetas de Acionamento
          </label>
          <select v-model="gavetasDeAcionamento" class="field_select" @change="updateSelectionGavetasDeAcionamento">
          <option value="" disabled selected>Selecione a opção</option>
          <option value="1">Mecânico</option>
          <option value="2">Pneumático</option>
          <option value="3">Hidráulico</option>
        </select>
        </div>
        <div class="section_field" v-else v-show="dados.gavetas.selectObject">
          <label class="">
            Gavetas de Acionamento
          </label>
          <select disabled class="field_select">
          <option v-if="dados.gavetas.mecanico === 'true'">Mecânico</option>
          <option v-else-if="dados.gavetas.pneumatico === 'true'">Pneumático</option>
          <option v-else-if="dados.gavetas.hidraulico === 'true'">Hidráulico</option>
          <option v-else> Nenhuma</option>
        </select>
        </div>
      </div>


    </div>
    <!-- Card personalizado -->
    <div class="">
      <div class="">
        <div class="row-2" v-show="showMoldePorCavidade && configInputs==0">
          <div class="one">
            <label class="">
              Código Produto
            </label>
            <input
              @change="mapProduct(this.codigoProduto)"
              list="ProdutsList"
              v-model="codigoProduto"
              v-maska="['##.###.######.##-##', '']"
              :class="['field', 'default_field_width']"
              placeholder="Digite o Código"
            />
            <div class="text-red" v-if="validationProduct === true">
              Código do Produto não encontrado no Sap.
            </div>
            <datalist id="ProdutsList">
              <div v-for="l in $store.state.emitData.produtos" :key="l.id">
                <option :value="l.cp">
                  {{ l.p }}
                </option>
              </div>
            </datalist>
          </div>

          <div class="one">
            <label class="">
              Produto
            </label>
            <input
              type="text"
              :class="['field', 'large_field_width']"
              :placeholder="descproduto"
              disabled
            />
          </div>

          <div class="one">
            <label class="">
              Nº Cavidades/Produto
            </label>
            <input
              v-maska="['##', '']"
              v-model="nCavidadeProduto"
              :class="['field', 'default_field_width']"
              placeholder="Descrição"
            />
          </div>
          <!-- Button add Cavidade / Produto -->
          <div class="button-section">
            <div class="btn-produto">
              <button
                type="button"
                @click.prevent="addCavidadeAndProduto"
                class="btn-button-produto"
              >
              Adicionar 
              <div class="sum"></div>
              </button>
            </div>
          </div>
        </div>
        <label v-if="dados.lista_ProdutoAndCavidades != 0">Listagem de Produtos Relacionados</label>
        <!-- Table List de Cavidade / Produtos -->
        <div>
            <table class="tableHistorico">
              <thead v-show="configInputs == 1" class="header">
                <tr>
                  <td class="field-table">Nº</td>
                  <th class="field-table">Código do Produto</th>
                  <th class="field-table">Produto</th>
                  <th class="field-table">Nº Cavidade</th>
                </tr>
            </thead>
              <tbody
                v-for="(l, index) in dados.lista_ProdutoAndCavidades"
                :key="l.idp"
              >
                <tr>
                  <td style="font-weight: 600;">{{ index + 1 }}. </td> 
                  <td data-title="Código  Produto">{{ l.produto.cp }}</td>
                  <td data-title="Produto">{{ l.produto.p }}</td>
                  <td data-title="Nº  Cavidade">{{ l.ncavidade }}</td>
                  <td class="btnDelete"  v-if="configInputs != 1">
                    <button
                      v-show="showMoldePorCavidade"
                      @click.prevent="excluir(index)"
                      type="button"
                    >
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
        </div>
      </div>
    </div>

    <!-- FIM TABLE -->

    <div>
      <div class="section_field">
        <label>
          Comentários Molde Aberto:
        </label>
        <textarea
          v-model="dados.observacao_tec"
          class="field_text"
          rows="5"
          cols="50"
          :placeholder="configInputs == 0 ? 'Escreva com no máximo 500 caracteres' : 'Nenhum comentário adicionado'"
          maxlength="500"
          :disabled="configInputs"
          style="resize: none"
        >
        </textarea>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { toRaw } from "vue";
import { sap } from "../../../../../../http";

export default {
  props: {
    configInputs: Number,
    Cavity: Number,
    molde: String,
    checkedCamara: Boolean,
    moldValid: {
    type: Boolean,
    default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  async created() {
    // const produto = await sap.get("/boms");
    // const maquina = await sap.get("/machines");
    // if (res) {

    // }
    // produto.data.results.map((item, index) => {
    //   this.lista_pro.push({
    //     id: index,
    //     cp: item.Code,
    //     p: item.Name,
    //     cmp: 200,
    //     // mp: item.materia,
    //   });
    // });

    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
    mounted() {
    this.$emit("dataMoldeAberto", this.dados);
  },
  updated() {
  if (this.Cavity && this.numeroTotaldeCavid !== this.Cavity) {
    this.numeroTotaldeCavid = this.Cavity;
  }
},

  data() {
    return {
      tiposDeInjeçãoOpcao: "",
      gavetasDeAcionamento:"",
      showMoldePorCavidade: true,
      validationProduct: false,
      validationMachine: false,
      lista_oficial: [],
      listmaquinas: [],
      lista_pro: [],
      listaProdutos: [],
      cod_product: "",
      numeroTotaldeCavid: this.Cavity || 0,
      codigoProduto: "",
      nCavidadeProduto: Number,
      contador: 0,
      BooleanTotalCavidade: false,
      descproduto: "Descrição Automática do SAP",
      tipoDeInjecaoIndireta: false,
      tipoDeInjecaoCamQuent: false,
      showcameraquente: false,

      dados: {
        lista_ProdutoAndCavidades: [],
        tipo_de_injecao: {
          direta: false,
          indireta: false,
          camera_quente: false,
          bico_quente: false,
        },
        tipo_de_entrada_de_injecao: "campo não usado",
        gavetas: {
          selectObject: false,
          lado_movel: "",
          lado_fixo: "",
          mecanico: false,
          pneumatico: false,
          hidraulico: false,
        },
        maquinas: {
          op1: "",
          op2: "",
          op3: "",
        },
        observacao_tec: "",
      },
    };
  },
  validations() {
    return {
      dados: {
        maquinas: {
          op1: {
            required,
          },
        },
        tipo_de_injecao: {
          required,
        },
        gavetas: {
          lado_movel: {
            // minValueValue: minValue(1),
            // numeric,
          },
          lado_fixo: {
            // minValueValue: minValue(1),
            // numeric,
          },
        },
      },
    };
  },
  methods: {
    async mapProduct(product) {
      this.$store.commit("SetLoading", true); 
      if (product.trim() === "") {
        this.validationProduct = false;
        this.$store.commit("SetLoading", false);
        return;
      }
      try {
    const { data: productOne } = await sap.get(`/cod_product`, {
      params: {
        unidade: "JPA",
        cod_product: product,
      },
    });
    if (!productOne || !productOne.codigo_produto) {
      this.lista_pro = [];
      this.descproduto = "";
      this.validationProduct = true;
        } else {
          this.lista_pro.push({
            id: 1,
            cp: productOne.codigo_produto,
            p: productOne.descricao_produto,
            cmp: 200,
          });

          this.descproduto = productOne.descricao_produto;
          this.validationProduct = false;
        }

      } catch (error) {
        this.lista_pro = [];
        this.descproduto = "";
        this.validationProduct = true;
        console.error("Erro ao buscar o produto:", error);
      } finally {
        this.$store.commit("SetLoading", false);
      }
    },
    async mapMachine() {
      if (this.listmaquinas.length === 0) {
        this.$store.commit("SetLoading", true); // insere o loading

        // Ok
        const { data: machines } = await sap.get(`/machine`, {
          params: {
            unidade: "JPA",
          },
        });

        if (!machines.results) {
          this.$store.commit("SetLoading", false);
          this.listmaquinas = [];
          this.validationMachine = true;
          return;
        }
        this.listmaquinas = machines.results;
        this.$store.commit("SetLoading", false);
      }
    },
    clickTipoDeInj(tipoDeEntrada) {
      switch (tipoDeEntrada) {
        case 1:
          this.tipoDeInjecaoIndireta = true;
          this.tipoDeInjecaoCamQuent = false;
          break;

        case 2:
          this.tipoDeInjecaoIndireta = false;
          this.tipoDeInjecaoCamQuent = true;
          break;

        default:
          this.tipoDeInjecaoIndireta = false;
          this.tipoDeInjecaoCamQuent = false;
      }
    },

    addCavidadeAndProduto() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
      const produto = this.lista_pro.find(
        (element) => element.cp === this.codigoProduto
      );

      const transformationArray = toRaw(this.$store.state.emitData.produtos);

      transformationArray.map((e) => {
        if (e.cp === this.codigoProduto) {
          this.cod_product = e.cp;
        }
      });

      const existeProduct = this.listaProdutos.find((e) => {
        return e.cp === this.codigoProduto;
      });

      if (existeProduct) {
        Toast.fire({
          icon: "error",
          title: "Código produto ja adicionado.",
          text: `Código produto ${this.codigoProduto} ja adicionado!`,
        });
        this.descproduto = "";
        this.codigoProduto = "";
        this.nCavidadeProduto = "";
        return;
      }
      this.listaProdutos.push({
        cp: this.cod_product,
      });


      let contTotal = this.contador + parseInt(this.nCavidadeProduto);
      const lista = {
        produto: produto,
        ncavidade: this.nCavidadeProduto,
      };
      if (isNaN(parseInt(this.numeroTotaldeCavid))) {
        Toast.fire({
          icon: "error",
          title: "Item não adicionado.",
          text: "Nº Total de Cavidades Vazio!",
        });
        this.listaProdutos = [];
        return;
      }
      if (isNaN(contTotal) && isNaN(parseInt(this.nCavidadeProduto))) {
        Toast.fire({
          icon: "error",
          title: "Item não adicionado.",
          text: "Verifique se o campos estão preenchidos!",
        });
        this.listaProdutos = [];
        return;
      }
      if (
        contTotal <= parseInt(this.numeroTotaldeCavid) &&
        parseInt(this.nCavidadeProduto) > 0
      ) {
        this.contador += parseInt(this.nCavidadeProduto);
        this.dados.lista_ProdutoAndCavidades.push(lista);
        this.BooleanTotalCavidade = true;
        this.descproduto = "";
        this.codigoProduto = "";
        this.nCavidadeProduto = "";
      } else {
        Toast.fire({
          icon: "error",
          title: "Item não adicionado.",
          text: "Limite de Cavidade Excedida!",
        });
        this.listaProdutos = [];
      }
    },

    excluir(index) {
      let ncavidade = this.dados.lista_ProdutoAndCavidades[index].ncavidade;

      this.contador -= ncavidade;
      this.dados.lista_ProdutoAndCavidades.splice(index, 1);
      this.listaProdutos.splice(index, 1);

      if (this.contador == 0) {
        this.BooleanTotalCavidade = false;
      }
    },

    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.MoldeAberto) {
        // Não Verificado
        const { data: moldeSapConsulta } = await sap.get(`/mold/`, {
          params: {
            unidade: "JPA",
            mold_code: this.$store.state.DataAllRRIM.InforGeral.MOLDE,
          },
        });

        this.numeroTotaldeCavid = moldeSapConsulta[0].cavidade;

        dataQuery.MoldeAberto[0].cavidade.map((element) => {
          this.dados.lista_ProdutoAndCavidades.push({
            produto: {
              cp: element.COD_PRODUTO,
              p: element.DESC_PRODUTO,
            },
            ncavidade: element.N_CAVIDADE,
          });

          // this.numeroTotaldeCavid = element.N_CAVIDADE;
        });

        this.dados.tipo_de_injecao.direta =
          dataQuery.MoldeAberto[0].TIPO_DE_INJ_DIR;
        this.dados.tipo_de_injecao.indireta =
          dataQuery.MoldeAberto[0].TIPO_DE_INJ_INDIR;
        this.dados.tipo_de_injecao.camera_quente =
          dataQuery.MoldeAberto[0].TIPO_DE_INJ_CAM;
        this.dados.tipo_de_injecao.bico_quente =
          dataQuery.MoldeAberto[0].TIPO_DE_INJ_BIC;
        if (this.dados.tipo_de_injecao.direta == "true") this.tiposDeInjeçãoOpcao = "1";
        else if (this.dados.tipo_de_injecao.indireta == "true") this.tiposDeInjeçãoOpcao = "2";
        else if (this.dados.tipo_de_injecao.bico_quente == "true") this.tiposDeInjeçãoOpcao = "3";
        else this.tiposDeInjeçãoOpcao = "none";
        this.dados.tipo_de_entrada_de_injecao =
          dataQuery.MoldeAberto[0].TIPO_DE_ENT_INJ;
        this.dados.gavetas.selectObject = dataQuery.MoldeAberto[0].GAVETAS;
        this.dados.gavetas.lado_movel =
          dataQuery.MoldeAberto[0].GAVETAS_L_MOVEL;
        this.dados.gavetas.lado_fixo = dataQuery.MoldeAberto[0].GAVETAS_L_FIXO;
        this.dados.gavetas.mecanico = dataQuery.MoldeAberto[0].GAVETAS_A_MEC;
        this.dados.gavetas.pneumatico = dataQuery.MoldeAberto[0].GAVETAS_A_PNE;
        this.dados.gavetas.hidraulico = dataQuery.MoldeAberto[0].GAVETAS_A_HID;

        this.dados.maquinas.op1 = dataQuery.MoldeAberto[0].MAQUINA_OP1;
        this.dados.maquinas.op2 = dataQuery.MoldeAberto[0].MAQUINA_OP2;
        this.dados.maquinas.op3 = dataQuery.MoldeAberto[0].MAQUINA_OP3;
        this.dados.observacao_tec = dataQuery.MoldeAberto[0].AVA_TEC;
      }
      if (dataQuery.InforGeral.homologacao[0].status !== 1) {
        this.showMoldePorCavidade = false;
      }
    },
    updateSelectionTipoDeInjecao() { 
      this.dados.tipo_de_injecao.direta = false;
      this.dados.tipo_de_injecao.indireta = false;
      this.dados.tipo_de_injecao.bico_quente = false;
      if (this.tiposDeInjeçãoOpcao === "1") {
        this.dados.tipo_de_injecao.direta = true;
        this.$emit("dataMoldeAberto", this.dados);
      } else if (this.tiposDeInjeçãoOpcao === "2") {
        this.dados.tipo_de_injecao.indireta = true;
        this.$emit("dataMoldeAberto", this.dados);
      } else if (this.tiposDeInjeçãoOpcao === "3") {
        this.dados.tipo_de_injecao.bico_quente = true;
        this.$emit("dataMoldeAberto", this.dados);
      }
    },
    updateSelectionGavetasDeAcionamento() {
      this.dados.gavetas.mecanico = false;
      this.dados.gavetas.pneumatico = false;
      this.dados.gavetas.hidraulico = false;
      if (this.gavetasDeAcionamento === "1") {
        this.dados.gavetas.mecanico = true;
      } else if (this.gavetasDeAcionamento === "2") {
        this.dados.gavetas.pneumatico = true;
      } else if (this.gavetasDeAcionamento === "3") {
        this.dados.gavetas.hidraulico = true;
    }
  },

  watch: {
    numeroTotaldeCavid(newValue) {
      this.$emit("setCavity", newValue);
    },
    async Cavity(newValue) {
      this.numeroTotaldeCavid = newValue;
    },
    codigoProduto(newValue) {
      const produto = this.lista_pro.find((element) => element.cp === newValue);
      if (produto) {
        this.descproduto = produto.p;
        return;
      }
      this.descproduto = "";
    },

    dados: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$emit("dataMoldeAberto", newValue);
      },
    },
  },
}};
</script>

<style scoped>

 @keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
} 

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
/* .btn-button-produto {
  height: 100%;
  width: 100%;
  cursor: pointer;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-color: var(--green);
  border-radius: 0.5rem;
  color:white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem;
}

.btn-produto {
  height: 2.5rem;
  width:11rem;
  animation: pulse 0.7s ease-in-out 5;
  display: flex;
  align-items: center;
  margin-top: auto;
  flex-direction: center;
  justify-content: center;
}

.sum {
    background-image: url(../../../../../../static/icons/+.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    height: 1rem!important;
    width: 1rem!important;
} */

.btn-button-produto {
  height: 100%;
  width: 100%;
  cursor: pointer;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-color: var(--green);
  border-radius: 0.5rem;
  color:white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem;

}

.sum {
    background-image: url(../../../../../../static/icons/+.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    height: 1rem!important;
    width: 1rem!important;
}

.button-section {
  display: flex;
  align-items: center;
}

.btn-produto {
  height: 2.5rem;
  width: 8rem;
  animation: pulse 0.7s ease-in-out 5;
  display: flex;
  align-items: center;
  margin-top: auto;
  flex-direction: center;
  justify-content: center;
}

.btn-button-produto:hover {
  background-color: var(--green_hover);
}

.btn-button-produto:focus {
  background-color: var(--green_focus);
}

label {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  color: var(--font_color);
}

.field_select {
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  height:2.5rem!important;
  width: 13rem!important;
  color: var(--font_color);
  padding-left: 1rem;
  cursor: pointer;
}

.field_select option {
  color: var(--font_color);
  background-color: #f0f0f0;
  border-radius: 5rem!important;
}


.field_select option:hover {
  background-color: #e0e0e0!important;
}

.field_select option:checked {
  background-color: var(--font_color); 
  border-radius: 5rem!important;
  color: white!important; 
}

.section_field {
  display: flex;
  flex-direction: column;
  gap:0rem;
}

.one {
  display: flex;
  flex-direction: column;
  gap:0rem;
}

.title {
  font-size: 0.8rem;
  font-weight: bold;
}

.row-1 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  margin-top: -0.5rem;
  margin-bottom: 1.55rem;
  color: var(--font_color);
  row-gap: 1rem!important;
}

.row-2 { 
  display: flex;
  align-items: top;
  gap: 20px;
  color: var(--font_color);
  margin-bottom: 1.1rem;
  margin-top: -0.5rem;
}

.field {
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  height:2.5rem!important;
  cursor: pointer;
  padding: 1rem;
  color: var(--font_color);
  cursor: text;
}

.field:hover {
  border: 1px solid var(--input_hover)!important;
  transition: border-color 0.5s ease;
}

.field:focus {
  border: 1px solid var(--green)!important;
}

.field::placeholder{
  color: rgb(65, 62, 62)!important;
}

.default_field_width {
  width: 13rem!important;
}

.large_field_width {
  width: 37rem!important;
}

.error {
  border-radius: 10px!important;
  padding: 1rem;
  color: var(--font_color);
  border: 1px solid red!important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: red;
  font-size: 0.8rem;
  width: 13rem!important;
  text-align: center!important;
}

.error:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--red);
  outline: 0;
}

.btnDelete {
  background-image: url('../../../../../../static/icons/trash.svg')!important;
  background-repeat: no-repeat;
  background-position: center;
  width: 2rem;
}

.btnDelete button{
  width: 2rem!important;
  height: 2rem!important;
  background-color: #d9d9d900;
}

td {
font-size: 0.8rem;
}

.tableHistorico {
  max-height: 7rem;
  overflow: auto;
  margin: 0rem 0rem 2rem;
  animation: fadeIn 1s ease forwards!important;
}


.tableHistorico thead tr td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.tableHistorico thead tr td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.tableHistorico tbody tr:last-child td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.tableHistorico tbody tr:last-child td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.tableHistorico tbody td {

  padding: 0.5rem;
}

.field_text {
  width: 100%!important;
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  height:5rem!important;
  padding: 0.5rem;
  color: var(--font_color);
}

.field_text:focus {
  border: 1px solid var(--green);
  transition: border-color 0.5s ease;
}

.header {
  background-color: white;
  color: var(--font_color);
  padding: 1rem 0rem!important;
}

.header tr td{
  padding: 1rem 0rem!important;
}

.field-table {
  font-size: 0.7rem;
  font-weight: 800;
}


@media (max-width: 1266px){
  .row-1{
    grid-template-columns: 1fr 1fr 1fr 1fr;
    width: 100%!important;
    gap: 1.5rem;
  }

  .section-field {
    width: 100%;

  }

  .field {
    width: 100%;
  }

    .row-2{
  flex-wrap: wrap;
  width: 100%!important;
}

.one {
  width: 100%;
}

  .default_field_width, .field_select, .text-red {
  width: 100%!important;
}

.large_field_width {
  width: 100%!important;
}

.button-section {
  height: auto;
}

}

@media (max-width: 1205px){
  .row-1, .row-2 {
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%!important;
  }
   .section-field {
    width: 15rem;

  }

  .large_field_width {
    width: 100rem;
  }
  .field, .field_select {
    width: 100%!important;
  }
}


@media (max-width: 983px){
    .row-1, .row-2 {
    grid-template-columns: 1fr 1fr;
    width: 100%!important;
  }

     .section-field {
    width: 18rem;

  }

  .field, .field_select {
    width: 100%!important;
  }
}
@media (max-width: 638px) {
  .tableHistorico thead {
    display: none;
  }

  .tableHistorico tbody, .tableHistorico tr, .tableHistorico td {
    display: block;
    width: 100%;
  }

  .tableHistorico tr {
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 0.8rem;
    background-color: white;
  }

  .tableHistorico td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 0;
    border: none;
    border-bottom: 1px solid #eee;
    font-size: 0.8rem;
  }

  .tableHistorico td:last-child {
    border-bottom: none;
  }

  .tableHistorico td::before {
    content: attr(data-title);
    font-weight: 600;
    color: var(--font_color);
    text-align: left;
  }
}


@media (max-width: 743px){

     .section-field {
    width: 15rem;

  }

  .field, .field_select {
    width: 100%!important;
  }

}

@media (max-width: 638px){

    .row-1, .row-2 {
    grid-template-columns: 1fr;
    width: 100%!important;
  }

    .section-field {
    width: 100%!important;
  }


}


</style>
